import { render, staticRenderFns } from "./HeaderText.vue?vue&type=template&id=19bf982d&scoped=true&"
import script from "./HeaderText.vue?vue&type=script&lang=js&"
export * from "./HeaderText.vue?vue&type=script&lang=js&"
import style0 from "./HeaderText.vue?vue&type=style&index=0&id=19bf982d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bf982d",
  null
  
)

export default component.exports